import React, { useCallback, useEffect, useState } from 'react'
import PageBanner from 'LuxKit/Banners/PageBanner'
import { getDismissed, setDismissed as sessionSetDismissed } from 'luxPlus/storage/renewalBanner'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyLuxPlusRenewalBonusEnabled from 'loyalty/selectors/getIsLoyaltyLuxPlusRenewalBonusEnabled'
import FormatLoyaltyStatusCredits from 'loyalty/components/Formatters/FormatLoyaltyStatusCredits'
import FormatLoyaltyBonusPoints from 'loyalty/components/Formatters/FormatLoyaltyBonusPoints'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS, LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS } from 'loyalty/constants/loyaltyBonusPoints'
import * as Analytics from 'analytics/analytics'
import purchaseLuxPlus from 'actions/luxPlus/purchaseLuxPlus'
import { fetchProductSubscription } from 'actions/LuxPlusActions'

function LuxPlusRenewalBanner() {
  const [dismissed, setDismissed] = useState(getDismissed())
  const isLoyaltyLuxPlusRenewalBonusEnabled = useAppSelector(getIsLoyaltyLuxPlusRenewalBonusEnabled)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchProductSubscription())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRenewal = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'manual_renewal_purchase',
      action: 'add_to_cart_lux_plus_standalone',
      category: LUXURY_PLUS.ANALYTICS_CATEGORY,
      type: 'interaction',
    })
    dispatch(purchaseLuxPlus({ hasJoinFee: false }))
  }, [dispatch])

  const renewalStatus = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item?.renewalStatus)
  const hasAutoRenewal = renewalStatus === 'ALLOW_RENEWAL'

  const dismiss = useCallback(() => {
    setDismissed(true)
    sessionSetDismissed()
  }, [])

  if (dismissed) return null

  return <PageBanner
    kind="critical"
    onDismiss={dismiss}
    primaryActionButtonProps={{
      onClick: handleRenewal,
      children: 'Renew now',
    }}
    secondaryActionButtonProps={{
      to: `/${LUXURY_PLUS_PATHS.ACCOUNT_MANAGEMENT_PAGE}`,
      children: 'Manage membership',
    }}
  >
    {hasAutoRenewal && <b>Your {LUXURY_PLUS.PROGRAM_NAME} Membership failed to renew due to to a payment issue.{' '}</b>}
    {!hasAutoRenewal && <b>Your {LUXURY_PLUS.PROGRAM_NAME} Membership will expire soon.{' '}</b>}
    {isLoyaltyLuxPlusRenewalBonusEnabled && <>Renew now to receive <b><FormatLoyaltyStatusCredits statusCredits={LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS} /> and <FormatLoyaltyBonusPoints points={LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS} /></b> with {getLoyaltyProgramDisplayName()}.</>}
    {!isLoyaltyLuxPlusRenewalBonusEnabled && <>Your benefits are on hold until payment is completed.</>}
  </PageBanner>
}

export default LuxPlusRenewalBanner
